var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Input, Select, Modal } from 'antd';
import { PlusOutlined, MinusOutlined, ArrowUpOutlined, ArrowDownOutlined, } from '@ant-design/icons';
import { useTranslation } from 'react-i18next'; // 导入 useTranslation
import GroupSelectionModal from './Modals/GroupSelectionModal'; // 导入 GroupSelectionModal 和 GroupItem
import DeclaredDifficultyEditorModal from './Modals/difficultyEditors/DeclaredDifficultyEditorModal'; // 导入 DeclaredDifficultyEditorModal
import SelectBonusModal from './Modals/SelectBonusModal'; // 导入 SelectBonusModal
import DifficultyValueEditorModal from './Modals/DifficultyValueEditorModal'; // 导入 DifficultyValueEditorModal
import SelectContentModal from './Modals/difficultyEditors/SelectContentModal'; // 导入 SelectContentModal 和 ContentItem
import DeclaredDifficultyHybridModal from './Modals/difficultyEditors/DeclaredDifficultyHybridModal'; // 导入 DeclaredDifficultyHybridModal 和相关接口
import DeclaredDifficultyAcroDuetModal from './Modals/difficultyEditors/DeclaredDifficultyAcroDuetModal'; // 导入 DeclaredDifficultyAcroDuetModal 和 AcroDuetItem
import api from '@/api';
const INITIAL_DATA_SOURCE = [
    { key: '1', time: '', part: '', index: 1, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '2', time: '', part: '', index: 2, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '3', time: '', part: '', index: 3, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '4', time: '', part: '', index: 4, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '5', time: '', part: '', index: 5, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '6', time: '', part: '', index: 6, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '7', time: '', part: '', index: 7, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '8', time: '', part: '', index: 8, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '9', time: '', part: '', index: 9, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '10', time: '', part: '', index: 10, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '11', time: '', part: '', index: 11, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '12', time: '', part: '', index: 12, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '13', time: '', part: '', index: 13, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '14', time: '', part: '', index: 14, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '15', time: '', part: '', index: 15, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '16', time: '', part: '', index: 16, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '17', time: '', part: '', index: 17, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '18', time: '', part: '', index: 18, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '19', time: '', part: '', index: 19, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '20', time: '', part: '', index: 20, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '21', time: '', part: '', index: 21, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '22', time: '', part: '', index: 22, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '23', time: '', part: '', index: 23, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '24', time: '', part: '', index: 24, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
    { key: '25', time: '', part: '', index: 25, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null },
];
const DataTable = ({ projectTech, onClearAll, onDataSourceChange, dataTableData }) => {
    const { t } = useTranslation(); // 调用 useTranslation Hook
    const [partList, setPartList] = useState([]); // 用于存储 getPartList 接口返回的数据
    const fetchDifficultyValue = (CurrentDataSource, record, index) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            const res = yield api.CoachCardApi.getScoresByCodes({
                base_mark: record.baseScore || '',
                declared_difficulty_code: record.declaredDifficulty || '',
                bonus_code: record.bonus || '',
                part: record.part || '',
                eventphase_type1: projectTech.substring(2) || ''
            });
            if (res.data.code === 200) {
                const newDifficultyValue = (parseFloat(((_a = res.data.data) === null || _a === void 0 ? void 0 : _a.declared_difficulty_score) || 0) + parseFloat(((_b = res.data.data) === null || _b === void 0 ? void 0 : _b.base_mark_score) || 0) + parseFloat(((_c = res.data.data) === null || _c === void 0 ? void 0 : _c.bonus_score) || 0)).toFixed(4) || '';
                const newDataSource = [...CurrentDataSource];
                newDataSource[index] = Object.assign(Object.assign({}, CurrentDataSource[index]), { difficultyValue: newDifficultyValue });
                onDataSourceChange(newDataSource);
            }
            else {
                const newDataSource = [...CurrentDataSource];
                newDataSource[index] = Object.assign(Object.assign({}, CurrentDataSource[index]), { difficultyValue: '' });
                onDataSourceChange(newDataSource);
            }
        }
        catch (error) {
            const newDataSource = [...CurrentDataSource];
            newDataSource[index] = Object.assign(Object.assign({}, CurrentDataSource[index]), { difficultyValue: '' });
            onDataSourceChange(newDataSource);
        }
    });
    // 辅助函数，用于更新 dataSource 并通知父组件
    const updateDataSource = (newDataSource) => {
        onDataSourceChange(newDataSource);
    };
    // 清除所有数据并重置表格
    const resetDataSource = () => {
        onDataSourceChange(INITIAL_DATA_SOURCE);
        setSelectedRowKey(null); // 清除选中状态
        // 重置所有模态框相关的状态
        setIsGroupSelectionModalVisible(false);
        setCurrentEditingGroupItem(null);
        setCurrentEditingRowIndexForGroup(null);
        setIsDeclaredDifficultyEditorVisible(false);
        setCurrentEditingDeclaredDifficultyItem(null);
        setCurrentEditingRowIndexForDeclaredDifficulty(null);
        setIsSelectBonusModalVisible(false);
        setCurrentSelectedBonusItem(null);
        setCurrentEditingRowIndexForBonus(null);
        setIsDifficultyValueEditorVisible(false);
        setCurrentSelectedDifficultyValueItem(null);
        setCurrentEditingRowIndexForDifficultyValue(null);
        setIsSelectContentModalVisible(false);
        setCurrentSelectedContentItem(null);
        setCurrentEditingRowIndexForContent(null);
        setIsDeclaredDifficultyHybridModalVisible(false);
        setCurrentEditingDeclaredDifficultyHybridItem(null);
        setCurrentEditingRowIndexForDeclaredDifficultyHybrid(null);
        setIsDeclaredDifficultyAcroDuetModalVisible(false);
        setCurrentEditingDeclaredDifficultyAcroDuetItem(null);
        setCurrentEditingRowIndexForDeclaredDifficultyAcroDuet(null);
        setCurrentEditingRow(null);
    };
    useEffect(() => {
        if (onClearAll) {
            onClearAll(resetDataSource);
        }
        //如果projectTech没有值，那么就不获取partList
        if (!projectTech) {
            setPartList([]);
            return;
        }
        getPartList();
    }, [projectTech, onClearAll]);
    //根据不同项目类型获取不同part的下拉列表数据
    const getPartList = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield api.CoachCardApi.getPartList({
            eventphase_type1: projectTech.substring(2),
        });
        if (res.data && res.data.code === 200) {
            setPartList(res.data.data);
        }
    });
    const [isGroupSelectionModalVisible, setIsGroupSelectionModalVisible] = useState(false);
    const [currentEditingGroupItem, setCurrentEditingGroupItem] = useState(null);
    const [currentEditingRowIndexForGroup, setCurrentEditingRowIndexForGroup] = useState(null);
    const [isDeclaredDifficultyEditorVisible, setIsDeclaredDifficultyEditorVisible] = useState(false);
    const [currentEditingDeclaredDifficultyItem, setCurrentEditingDeclaredDifficultyItem] = useState(null);
    const [currentEditingRowIndexForDeclaredDifficulty, setCurrentEditingRowIndexForDeclaredDifficulty] = useState(null);
    const [isSelectBonusModalVisible, setIsSelectBonusModalVisible] = useState(false); // 控制 SelectBonusModal 的显示
    const [currentSelectedBonusItem, setCurrentSelectedBonusItem] = useState(null); // 存储 SelectBonusModal 的选中项
    const [currentEditingRowIndexForBonus, setCurrentEditingRowIndexForBonus] = useState(null); // 存储当前编辑行的索引
    const [isDifficultyValueEditorVisible, setIsDifficultyValueEditorVisible] = useState(false); // 控制 DifficultyValueEditorModal 的显示
    const [currentSelectedDifficultyValueItem, setCurrentSelectedDifficultyValueItem] = useState(null); // 存储 DifficultyValueEditorModal 的选中项
    const [currentEditingRowIndexForDifficultyValue, setCurrentEditingRowIndexForDifficultyValue] = useState(null); // 存储当前编辑行的索引
    const [currentEditingRow, setCurrentEditingRow] = useState(null); // 存储当前编辑行的数据
    // SelectContentModal 的状态
    const [isSelectContentModalVisible, setIsSelectContentModalVisible] = useState(false);
    const [currentSelectedContentItem, setCurrentSelectedContentItem] = useState(null);
    const [currentEditingRowIndexForContent, setCurrentEditingRowIndexForContent] = useState(null);
    // DeclaredDifficultyHybridModal 的状态
    const [isDeclaredDifficultyHybridModalVisible, setIsDeclaredDifficultyHybridModalVisible] = useState(false);
    const [currentEditingDeclaredDifficultyHybridItem, setCurrentEditingDeclaredDifficultyHybridItem] = useState(null);
    const [currentEditingRowIndexForDeclaredDifficultyHybrid, setCurrentEditingRowIndexForDeclaredDifficultyHybrid] = useState(null);
    // DeclaredDifficultyAcroDuetModal 的状态
    const [isDeclaredDifficultyAcroDuetModalVisible, setIsDeclaredDifficultyAcroDuetModalVisible] = useState(false);
    const [currentEditingDeclaredDifficultyAcroDuetItem, setCurrentEditingDeclaredDifficultyAcroDuetItem] = useState(null);
    const [currentEditingRowIndexForDeclaredDifficultyAcroDuet, setCurrentEditingRowIndexForDeclaredDifficultyAcroDuet] = useState(null);
    const [selectedRowKey, setSelectedRowKey] = useState(null); // 添加这一行
    const showGroupSelectionModal = (record, index) => {
        setCurrentEditingGroupItem(record.selectedGroup || null);
        setCurrentEditingRowIndexForGroup(index);
        setCurrentEditingRow(record); // 设置当前编辑行的数据
        setIsGroupSelectionModalVisible(true);
    };
    const handleGroupSelectionModalOk = (selectedGroup) => {
        if (currentEditingRowIndexForGroup !== null) {
            const newDataSource = [...dataTableData];
            newDataSource[currentEditingRowIndexForGroup] = Object.assign(Object.assign({}, newDataSource[currentEditingRowIndexForGroup]), { baseScore: selectedGroup ? ((selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.code) !== undefined ? selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.code.toString() : '') : '', declaredDifficulty: '', selectedGroup: selectedGroup });
            onDataSourceChange(newDataSource);
            // 在更新数据后，为当前行调用 fetchDifficultyValue
            fetchDifficultyValue(newDataSource, newDataSource[currentEditingRowIndexForGroup], currentEditingRowIndexForGroup);
        }
        setIsGroupSelectionModalVisible(false);
        setCurrentEditingGroupItem(null);
        setCurrentEditingRowIndexForGroup(null);
        setCurrentEditingRow(null); // 清除当前编辑行的数据
    };
    const handleGroupSelectionModalCancel = () => {
        setIsGroupSelectionModalVisible(false);
        setCurrentEditingGroupItem(null);
        setCurrentEditingRowIndexForGroup(null);
        setCurrentEditingRow(null); // 清除当前编辑行的数据
    };
    // 申报难度其中一种弹框
    const showDeclaredDifficultyEditorModal = (record, index) => {
        setCurrentEditingDeclaredDifficultyItem(record.selectedDeclaredDifficulty || null);
        setCurrentEditingRowIndexForDeclaredDifficulty(index);
        setCurrentEditingRow(record); // Set the current editing row
        setIsDeclaredDifficultyEditorVisible(true);
    };
    //申报难度第二种弹框
    const showSelectContentModal = (record, index) => {
        setCurrentSelectedContentItem(record.selectedContent || null);
        setCurrentEditingRowIndexForContent(index);
        setCurrentEditingRow(record); // 确保 currentEditingRow 被设置
        setIsSelectContentModalVisible(true);
    };
    //申报难度第三种弹框
    const showDeclaredDifficultyHybridModal = (record, index) => {
        setCurrentEditingDeclaredDifficultyHybridItem(record.selectedDeclaredDifficultyHybrid || null);
        setCurrentEditingRowIndexForDeclaredDifficultyHybrid(index);
        setCurrentEditingRow(record); // 确保 currentEditingRow 被设置
        setIsDeclaredDifficultyHybridModalVisible(true);
    };
    const handleDeclaredDifficultyEditorOk = (selectedData) => {
        if (currentEditingRowIndexForDeclaredDifficulty !== null) {
            const newDataSource = [...dataTableData];
            newDataSource[currentEditingRowIndexForDeclaredDifficulty] = Object.assign(Object.assign({}, newDataSource[currentEditingRowIndexForDeclaredDifficulty]), { declaredDifficulty: (selectedData === null || selectedData === void 0 ? void 0 : selectedData.ShowdifficultyValue) || '', selectedDeclaredDifficulty: selectedData });
            onDataSourceChange(newDataSource);
            // 在更新数据后，为当前行调用 fetchDifficultyValue
            fetchDifficultyValue(newDataSource, newDataSource[currentEditingRowIndexForDeclaredDifficulty], currentEditingRowIndexForDeclaredDifficulty);
        }
        setIsDeclaredDifficultyEditorVisible(false);
        setCurrentEditingDeclaredDifficultyItem(null);
        setCurrentEditingRowIndexForDeclaredDifficulty(null);
    };
    const handleDeclaredDifficultyEditorCancel = () => {
        setIsDeclaredDifficultyEditorVisible(false);
        setCurrentEditingDeclaredDifficultyItem(null);
        setCurrentEditingRowIndexForDeclaredDifficulty(null);
    };
    const showSelectBonusModal = (record, index) => {
        setCurrentSelectedBonusItem(record.selectedBonus || null);
        setCurrentEditingRowIndexForBonus(index);
        setIsSelectBonusModalVisible(true);
    };
    const handleSelectBonusModalOk = (selectedItem) => {
        if (currentEditingRowIndexForBonus !== null) {
            const newDataSource = [...dataTableData];
            newDataSource[currentEditingRowIndexForBonus] = Object.assign(Object.assign({}, newDataSource[currentEditingRowIndexForBonus]), { bonus: selectedItem ? selectedItem.categoryCode : '', selectedBonus: selectedItem });
            onDataSourceChange(newDataSource);
            // 在更新数据后，为当前行调用 fetchDifficultyValue
            fetchDifficultyValue(newDataSource, newDataSource[currentEditingRowIndexForBonus], currentEditingRowIndexForBonus);
        }
        setIsSelectBonusModalVisible(false);
        setCurrentSelectedBonusItem(null);
        setCurrentEditingRowIndexForBonus(null);
    };
    const handleSelectBonusModalCancel = () => {
        setIsSelectBonusModalVisible(false);
        setCurrentSelectedBonusItem(null);
        setCurrentEditingRowIndexForBonus(null);
    };
    const showDifficultyValueEditorModal = (record, index) => {
        setCurrentSelectedDifficultyValueItem(record.selectedDifficultyValue || null);
        setCurrentEditingRowIndexForDifficultyValue(index);
        setCurrentEditingRow(record);
        setIsDifficultyValueEditorVisible(true);
    };
    const handleDifficultyValueEditorOk = (selectedItem) => {
        if (currentEditingRowIndexForDifficultyValue !== null) {
            const newDataSource = [...dataTableData];
            newDataSource[currentEditingRowIndexForDifficultyValue] = Object.assign(Object.assign({}, newDataSource[currentEditingRowIndexForDifficultyValue]), { difficultyValue: selectedItem ? selectedItem.dd : '', selectedDifficultyValue: selectedItem });
            onDataSourceChange(newDataSource);
        }
        setIsDifficultyValueEditorVisible(false);
        setCurrentSelectedDifficultyValueItem(null);
        setCurrentEditingRowIndexForDifficultyValue(null);
        setCurrentEditingRow(null); // Clear the current editing row
    };
    const handleDifficultyValueEditorCancel = () => {
        setIsDifficultyValueEditorVisible(false);
        setCurrentSelectedDifficultyValueItem(null);
        setCurrentEditingRowIndexForDifficultyValue(null);
        setCurrentEditingRow(null); // Clear the current editing row
    };
    const handleSelectContentModalOk = (selectedItem) => {
        if (currentEditingRowIndexForContent !== null) {
            const newDataSource = [...dataTableData];
            newDataSource[currentEditingRowIndexForContent] = Object.assign(Object.assign({}, newDataSource[currentEditingRowIndexForContent]), { declaredDifficulty: selectedItem ? selectedItem.code + '' + selectedItem.categoryCode : '', selectedDeclaredDifficulty: selectedItem });
            onDataSourceChange(newDataSource);
            // 在更新数据后，为当前行调用 fetchDifficultyValue
            fetchDifficultyValue(newDataSource, newDataSource[currentEditingRowIndexForContent], currentEditingRowIndexForContent);
        }
        setIsSelectContentModalVisible(false);
        setCurrentSelectedContentItem(null);
        setCurrentEditingRowIndexForContent(null);
        setCurrentEditingRow(null);
    };
    const handleSelectContentModalCancel = () => {
        setIsSelectContentModalVisible(false);
        setCurrentSelectedContentItem(null);
        setCurrentEditingRowIndexForContent(null);
        setCurrentEditingRow(null);
    };
    const handleDeclaredDifficultyHybridModalOk = (selectedData) => {
        var _a, _b;
        if (currentEditingRowIndexForDeclaredDifficultyHybrid !== null) {
            const newDataSource = [...dataTableData];
            newDataSource[currentEditingRowIndexForDeclaredDifficultyHybrid] = Object.assign(Object.assign({}, newDataSource[currentEditingRowIndexForDeclaredDifficultyHybrid]), { declaredDifficulty: selectedData
                    ? ((currentEditingRow === null || currentEditingRow === void 0 ? void 0 : currentEditingRow.declaredDifficulty) && ((_a = selectedData.detail) === null || _a === void 0 ? void 0 : _a.categoryCode)
                        ? `${currentEditingRow.declaredDifficulty},${selectedData.detail.categoryCode}${parseFloat(selectedData.percentage) / 100 === 1 ? '' : `*${parseFloat(selectedData.percentage) / 100}`}`
                        : (((_b = selectedData.detail) === null || _b === void 0 ? void 0 : _b.categoryCode) ? `${selectedData.detail.categoryCode}${parseFloat(selectedData.percentage) / 100 === 1 ? '' : `*${parseFloat(selectedData.percentage) / 100}`}` : ''))
                    : '', selectedDeclaredDifficultyHybrid: selectedData });
            onDataSourceChange(newDataSource);
            // 在更新数据后，为当前行调用 fetchDifficultyValue
            fetchDifficultyValue(newDataSource, newDataSource[currentEditingRowIndexForDeclaredDifficultyHybrid], currentEditingRowIndexForDeclaredDifficultyHybrid);
        }
        setIsDeclaredDifficultyHybridModalVisible(false);
        setCurrentEditingDeclaredDifficultyHybridItem(null);
        setCurrentEditingRowIndexForDeclaredDifficultyHybrid(null);
        setCurrentEditingRow(null);
    };
    const handleDeclaredDifficultyHybridModalCancel = () => {
        setIsDeclaredDifficultyHybridModalVisible(false);
        setCurrentEditingDeclaredDifficultyHybridItem(null);
        setCurrentEditingRowIndexForDeclaredDifficultyHybrid(null);
        setCurrentEditingRow(null);
    };
    // 申报难度 AcroDuet 弹框
    const showDeclaredDifficultyAcroDuetModal = (record, index) => {
        setCurrentEditingDeclaredDifficultyAcroDuetItem(record.selectedDeclaredDifficultyAcroDuet || null);
        setCurrentEditingRowIndexForDeclaredDifficultyAcroDuet(index);
        setCurrentEditingRow(record);
        setIsDeclaredDifficultyAcroDuetModalVisible(true);
    };
    const handleDeclaredDifficultyAcroDuetModalOk = (selectedData) => {
        if (currentEditingRowIndexForDeclaredDifficultyAcroDuet !== null) {
            const newDataSource = [...dataTableData];
            newDataSource[currentEditingRowIndexForDeclaredDifficultyAcroDuet] = Object.assign(Object.assign({}, newDataSource[currentEditingRowIndexForDeclaredDifficultyAcroDuet]), { declaredDifficulty: (selectedData === null || selectedData === void 0 ? void 0 : selectedData.code) || '', selectedDeclaredDifficultyAcroDuet: selectedData });
            onDataSourceChange(newDataSource);
            // 在更新数据后，为当前行调用 fetchDifficultyValue
            fetchDifficultyValue(newDataSource, newDataSource[currentEditingRowIndexForDeclaredDifficultyAcroDuet], currentEditingRowIndexForDeclaredDifficultyAcroDuet);
        }
        setIsDeclaredDifficultyAcroDuetModalVisible(false);
        setCurrentEditingDeclaredDifficultyAcroDuetItem(null);
        setCurrentEditingRowIndexForDeclaredDifficultyAcroDuet(null);
        setCurrentEditingRow(null);
    };
    const handleDeclaredDifficultyAcroDuetModalCancel = () => {
        setIsDeclaredDifficultyAcroDuetModalVisible(false);
        setCurrentEditingDeclaredDifficultyAcroDuetItem(null);
        setCurrentEditingRowIndexForDeclaredDifficultyAcroDuet(null);
        setCurrentEditingRow(null);
    };
    // 辅助函数：判断一行是否有数据
    const isRowDataPresent = (record) => {
        return (record.time !== '' ||
            record.part !== '' ||
            record.baseScore !== '' ||
            record.declaredDifficulty !== '' ||
            record.bonus !== '' ||
            record.difficultyValue !== '' ||
            record.tc !== '' ||
            record.selectedGroup !== null ||
            record.selectedDeclaredDifficulty !== null ||
            record.selectedBonus !== null ||
            record.selectedDifficultyValue !== null ||
            record.selectedContent !== null ||
            record.selectedDeclaredDifficultyHybrid !== null);
    };
    // 移动行向下
    const handleMoveDown = () => {
        if (selectedRowKey === null)
            return;
        const currentIndex = dataTableData.findIndex((item) => item.key === selectedRowKey);
        if (currentIndex === -1 || currentIndex === dataTableData.length - 1)
            return; // 已经是最后一行或未找到
        const newDataSource = [...dataTableData];
        const [movedRow] = newDataSource.splice(currentIndex, 1);
        newDataSource.splice(currentIndex + 1, 0, movedRow);
        // 更新 index 字段
        newDataSource.forEach((item, idx) => {
            item.index = idx + 1;
            item.key = (idx + 1).toString(); // 确保 key 也更新
        });
        onDataSourceChange(newDataSource);
        // 保持选中状态
        setSelectedRowKey(movedRow.key);
    };
    // 清除行数据
    const handleClearRow = () => {
        if (selectedRowKey === null)
            return;
        Modal.confirm({
            title: '',
            content: 'Are you sure to clear this row?',
            onOk() {
                const currentIndex = dataTableData.findIndex((item) => item.key === selectedRowKey);
                if (currentIndex === -1)
                    return;
                const newDataSource = [...dataTableData];
                // 创建一个空的 DataType 对象，但保留 key 和 index
                const clearedRow = Object.assign(Object.assign({}, INITIAL_DATA_SOURCE[0]), { key: newDataSource[currentIndex].key, index: newDataSource[currentIndex].index });
                newDataSource[currentIndex] = clearedRow;
                onDataSourceChange(newDataSource);
                setSelectedRowKey(null); // 清除选中状态
            },
            onCancel() {
                // 用户取消，不执行任何操作
            },
        });
    };
    // 添加行
    const handleAddRow = () => {
        const newRow = Object.assign(Object.assign({}, INITIAL_DATA_SOURCE[0]), { key: (dataTableData.length + 1).toString(), index: dataTableData.length + 1 });
        let newDataSource = [...dataTableData];
        let insertIndex = newDataSource.length; // 默认添加到末尾
        if (selectedRowKey !== null) {
            const currentIndex = newDataSource.findIndex(item => item.key === selectedRowKey);
            if (currentIndex !== -1) {
                insertIndex = currentIndex + 1;
            }
        }
        newDataSource.splice(insertIndex, 0, newRow);
        // 重新排序和更新 key
        newDataSource.forEach((item, idx) => {
            item.index = idx + 1;
            item.key = (idx + 1).toString();
        });
        onDataSourceChange(newDataSource);
        setSelectedRowKey(newRow.key); // 选中新添加的行
    };
    // 移动行向上
    const handleMoveUp = () => {
        if (selectedRowKey === null)
            return;
        const currentIndex = dataTableData.findIndex((item) => item.key === selectedRowKey);
        if (currentIndex === -1 || currentIndex === 0)
            return; // 已经是第一行或未找到
        const newDataSource = [...dataTableData];
        const [movedRow] = newDataSource.splice(currentIndex, 1);
        newDataSource.splice(currentIndex - 1, 0, movedRow);
        // 更新 index 字段
        newDataSource.forEach((item, idx) => {
            item.index = idx + 1;
            item.key = (idx + 1).toString(); // 确保 key 也更新
        });
        onDataSourceChange(newDataSource);
        // 保持选中状态
        setSelectedRowKey(movedRow.key);
    };
    const columns = [
        {
            title: t('datatable.time'),
            dataIndex: 'time',
            key: 'time',
            width: 30,
            render: (value, record, index) => (<Input placeholder='0:00-0:01' value={record.time} onChange={(e) => {
                    const newDataSource = [...dataTableData];
                    newDataSource[index] = Object.assign(Object.assign({}, newDataSource[index]), { time: e.target.value });
                    onDataSourceChange(newDataSource);
                }}/>),
        },
        {
            title: t('datatable.part'),
            dataIndex: 'part',
            key: 'part',
            width: 30,
            render: (value, record, index) => {
                return (<div>
            <Select value={record.part} options={partList.map(item => ({ label: item.part_name, value: item.part_code }))} style={{ width: '100%' }} onChange={(selectedValue) => {
                        const newDataSource = [...dataTableData];
                        newDataSource[index] = Object.assign(Object.assign({}, newDataSource[index]), { part: selectedValue, index: index + 1, baseScore: '', declaredDifficulty: '', bonus: '', difficultyValue: '', tc: '', selectedGroup: null, selectedDeclaredDifficulty: null, selectedBonus: null, selectedDifficultyValue: null, selectedContent: null, selectedDeclaredDifficultyHybrid: null, selectedDeclaredDifficultyAcroDuet: null });
                        onDataSourceChange(newDataSource);
                    }}/>
          </div>);
            },
        },
        {
            title: t('datatable.index'),
            dataIndex: 'index',
            key: 'index',
            width: 30,
            render: (value, record) => {
                var _a;
                return (<Input disabled={false} readOnly value={isRowDataPresent(record) ? (_a = record === null || record === void 0 ? void 0 : record.index) === null || _a === void 0 ? void 0 : _a.toString() : ''}/>);
            },
        },
        {
            title: t('datatable.base_mark'),
            dataIndex: 'baseScore',
            key: 'baseScore',
            width: 30,
            render: (value, record, index) => (<Input value={record.baseScore} onClick={() => {
                    if (!record.part) {
                        Modal.warning({
                            title: '',
                            content: t('datatable.please_select_part_first'),
                        });
                        return;
                    }
                    if (record.part == 'HYBRID' || record.part == 'ReqHY') {
                        Modal.warning({
                            title: '',
                            content: t('datatable.base_mark_for_hybrids'), //所有混合项目的基准分均为 0.50
                        });
                        return;
                    }
                    if (record.part !== 'ACRO') {
                        Modal.warning({
                            title: '',
                            content: t('datatable.base_marks_only_acrobatics'), //抱歉，基准分仅适用于技巧项目
                        });
                        return;
                    }
                    if (projectTech.substring(2).indexOf('DUET') >= 0) {
                        Modal.warning({
                            title: '',
                            content: t('datatable.base_mark_for_pair_acrobatics'), //所有双人技巧项目的基准分均为 0.10
                        });
                        return;
                    }
                    showGroupSelectionModal(record, index);
                }}/>),
        },
        {
            title: t('datatable.declared_difficulty'),
            dataIndex: 'declaredDifficulty',
            key: 'declaredDifficulty',
            width: 100,
            render: (value, record, index) => (<Input value={record.declaredDifficulty} onClick={() => {
                    if (!record.part) {
                        Modal.warning({
                            title: '',
                            content: t('datatable.please_select_part_first'),
                        });
                        return;
                    }
                    if (record.part == 'TRANS' || record.part == 'SuCon') {
                        Modal.warning({
                            title: '',
                            content: t('datatable.difficulties_not_apply_transitions'), //抱歉，难度不适用于过渡项目
                        });
                        return;
                    }
                    if (record.part == 'ChoHy') {
                        Modal.warning({
                            title: '',
                            content: t('datatable.difficulties_not_apply_choreography_hybrids'), //抱歉，难度不适用于编排混合项目
                        });
                        return;
                    }
                    if ((projectTech.substring(2) == 'TEAM_TECH' || projectTech.substring(2) == 'FREE_TEAM' || projectTech.substring(2) == 'FREE_COMBINATION') && record.baseScore === '' && record.part == 'ACRO') {
                        Modal.warning({
                            title: '',
                            content: t('modal.please_select_base_mark_first'), // 这里可能需要一个不同的翻译键，因为内容与上面重复
                        });
                        return;
                    }
                    //根据part类型和eventphase_type1类型的不同跳转到不同的选择器页面
                    if (record.part === 'TRE') {
                        showSelectContentModal(record, index);
                    }
                    else if (record.part === 'ACRO') {
                        if (projectTech.indexOf('DUET') >= 0) {
                            showDeclaredDifficultyAcroDuetModal(record, index);
                        }
                        else if (record.baseScore !== '') {
                            showDeclaredDifficultyEditorModal(record, index);
                        }
                        else {
                            //如果基准分是空的,提示需要填基准分
                            Modal.warning({
                                title: '',
                                content: t('modal.please_select_base_mark_first'),
                            });
                            return;
                        }
                    }
                    else if (record.part === 'HYBRID' || record.part === 'ReqHY') {
                        showDeclaredDifficultyHybridModal(record, index);
                    }
                }}/>)
        },
        {
            title: t('datatable.bonus'),
            dataIndex: 'bonus',
            key: 'bonus',
            width: 30,
            render: (value, record, index) => (<Input value={record.bonus} onClick={() => {
                    if (!record.part) {
                        Modal.warning({
                            title: '',
                            content: t('datatable.please_select_part_first'),
                        });
                        return;
                    }
                    const allowedProjectTechs = ['TEAM_TECH', 'TEAM_FREE', 'FREE_COMBINATION'];
                    if (!allowedProjectTechs.includes(projectTech.substring(2))) {
                        Modal.warning({
                            title: '',
                            content: t('datatable.bonuses_only_team_free_tech_combo'), //抱歉，加分仅适用于集体自由、集体技术和自由组合
                        });
                        return;
                    }
                    if (record.part !== 'HYBRID') {
                        Modal.warning({
                            title: '',
                            content: t('datatable.bonuses_only_hybrids'), //抱歉，加分仅适用于混合项目
                        });
                        return;
                    }
                    showSelectBonusModal(record, index);
                }}/>),
        },
        {
            title: t('datatable.difficulty_degree'),
            dataIndex: 'difficultyValue',
            key: 'difficultyValue',
            width: 30,
            render: (value, record, index) => {
                return (<Input value={record.difficultyValue} readOnly onClick={() => {
                        if (!record.part) {
                            Modal.warning({
                                title: '',
                                content: t('datatable.please_select_part_first'),
                            });
                            return;
                        }
                        showDifficultyValueEditorModal(record, index);
                    }}/>);
            },
        },
        {
            title: t('datatable.tc'),
            dataIndex: 'tc',
            key: 'tc',
            width: 30,
            render: (value, record) => (<Input onClick={() => { }} readOnly style={{ backgroundColor: record.tcStatus === 'invalid' ? 'rgb(255, 204, 204)' : 'transparent' }}/>),
        },
    ];
    return (<div style={{ backgroundColor: 'rgb(249, 249, 249)' }}>
      <Space size="middle" direction="horizontal" style={{ display: 'flex', alignItems: 'center', backgroundColor: 'rgb(249, 249, 249)' }}>
        <Button icon={<PlusOutlined />} onClick={handleAddRow}/>
        <Button icon={<MinusOutlined />} onClick={handleClearRow}/>
        <Button icon={<ArrowUpOutlined />} onClick={handleMoveUp}/>
        <Button icon={<ArrowDownOutlined />} onClick={handleMoveDown}/>
      </Space>
      <div style={{ display: 'flex', marginTop: 20, border: '1px solid #ccc', backgroundColor: 'rgb(249, 249, 249)' }}>
        <div style={{ flexGrow: 1, overflowX: 'auto' }}>
          <Table dataSource={dataTableData} columns={columns} pagination={false} size="small" bordered scroll={{ y: 500 }} // 添加垂直滚动
     onRow={(record) => {
            if (!record)
                return {}; // 添加空值检查
            return {
                onClick: () => {
                    setSelectedRowKey(record.key); // 更新选中行的 key
                },
                style: {
                    backgroundColor: selectedRowKey === record.key ? '#e6f7ff' : 'transparent',
                    cursor: 'pointer',
                },
            };
        }}/>
        </div>
      </div>

      <GroupSelectionModal visible={isGroupSelectionModalVisible} onOk={handleGroupSelectionModalOk} onCancel={handleGroupSelectionModalCancel} initialSelectedGroup={currentEditingGroupItem} currentRecord={currentEditingRow} projectTech={projectTech}/>
      {/* 不同种类的申报难度弹框 */}
      <DeclaredDifficultyEditorModal visible={isDeclaredDifficultyEditorVisible} onOk={handleDeclaredDifficultyEditorOk} onCancel={handleDeclaredDifficultyEditorCancel} initialSelectedData={currentEditingDeclaredDifficultyItem} currentRecord={currentEditingRow} projectTech={projectTech}/>
      <SelectContentModal visible={isSelectContentModalVisible} onOk={handleSelectContentModalOk} onCancel={handleSelectContentModalCancel} initialSelectedItem={currentSelectedContentItem} currentRecord={currentEditingRow} projectTech={projectTech}/>
      <DeclaredDifficultyHybridModal visible={isDeclaredDifficultyHybridModalVisible} onOk={handleDeclaredDifficultyHybridModalOk} onCancel={handleDeclaredDifficultyHybridModalCancel} initialSelectedData={currentEditingDeclaredDifficultyHybridItem} currentRecord={currentEditingRow} projectTech={projectTech}/>
      <DeclaredDifficultyAcroDuetModal visible={isDeclaredDifficultyAcroDuetModalVisible} onOk={handleDeclaredDifficultyAcroDuetModalOk} onCancel={handleDeclaredDifficultyAcroDuetModalCancel} initialSelectedItem={currentEditingDeclaredDifficultyAcroDuetItem} currentRecord={currentEditingRow} projectTech={projectTech}/>
      {/* 加分弹框 */}
      <SelectBonusModal visible={isSelectBonusModalVisible} onOk={handleSelectBonusModalOk} onCancel={handleSelectBonusModalCancel} initialSelectedItem={currentSelectedBonusItem}/>
      <DifficultyValueEditorModal visible={isDifficultyValueEditorVisible} onOk={handleDifficultyValueEditorOk} onCancel={handleDifficultyValueEditorCancel} initialSelectedItem={currentSelectedDifficultyValueItem} baseMark={parseFloat((currentEditingRow === null || currentEditingRow === void 0 ? void 0 : currentEditingRow.baseScore) || '0')} declaredDifficulty={parseFloat((currentEditingRow === null || currentEditingRow === void 0 ? void 0 : currentEditingRow.declaredDifficulty) || '0')} bonus={parseFloat((currentEditingRow === null || currentEditingRow === void 0 ? void 0 : currentEditingRow.bonus) || '0')} totalDD={parseFloat((currentEditingRow === null || currentEditingRow === void 0 ? void 0 : currentEditingRow.baseScore) || '0') +
            parseFloat((currentEditingRow === null || currentEditingRow === void 0 ? void 0 : currentEditingRow.declaredDifficulty) || '0') +
            parseFloat((currentEditingRow === null || currentEditingRow === void 0 ? void 0 : currentEditingRow.bonus) || '0')} currentRecord={currentEditingRow} projectTech={projectTech}/>
    </div>);
};
export default DataTable;
